'use client';

import { useSession, signOut } from "next-auth/react";
import { useEffect } from "react";

export const SessionErrorHandler = () => {
  const { data: session } = useSession();

  useEffect(() => {
    if (session?.error === "RefreshTokenExpired") {
      signOut({ callbackUrl: "/" });
    }
  }, [session?.error]);

  return null;
};